// extracted by mini-css-extract-plugin
export default {"inputWrapper":"inputWrapper__GkmfQ","wrapper":"wrapper__pSzNf"};